export class ListMaintenanceRunsFilterConditions {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "runType",
            "baseName": "runType",
            "type": "MaintenanceRunTypeFilters",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "MaintenanceRunStatusFilters",
            "format": ""
        },
        {
            "name": "catalogId",
            "baseName": "catalogId",
            "type": "IdFilters",
            "format": ""
        },
        {
            "name": "databaseName",
            "baseName": "databaseName",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "tableName",
            "baseName": "tableName",
            "type": "StringFilters",
            "format": ""
        },
        {
            "name": "startedAt",
            "baseName": "startedAt",
            "type": "DateRangeFilter",
            "format": ""
        },
        {
            "name": "finishedAt",
            "baseName": "finishedAt",
            "type": "DateRangeFilter",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return ListMaintenanceRunsFilterConditions.attributeTypeMap;
    }
    constructor() {
    }
}
